import { render, staticRenderFns } from "./folders-drop-search-employees.vue?vue&type=template&id=1491b50a&scoped=true"
import script from "./folders-drop-search-employees.vue?vue&type=script&lang=js"
export * from "./folders-drop-search-employees.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1491b50a",
  null
  
)

export default component.exports